module.exports = __webpack_public_path__ + "assets/img/syj.023733be.png";